import { styled, Box, TextField } from "@mui/material";

export const HeaderContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "95%",
  marginBottom: "5px",
});

export const SegmentTitleTextField = styled(TextField)(
  ({
    fontWeightValue = "500",
    fontSizeValue = "16px",
    backgroundColor = "white",
  }) => ({
    fontWeight: "900",
    fontFamily: "DM Sans",

    "& input": {
      fontFamily: "DM Sans",
      fontSize: fontSizeValue,
      fontWeight: fontWeightValue,
      lineHeight: "20px",
      letterSpacing: "0em",
      textAlign: "left",
      color: "#565556",
      backgroundColor,
      // width: "75%",
      height: "38px",
      borderRadius: "8px",
      padding: "0px 15px",
    },

    "& textarea": {
      fontFamily: "DM Sans",
      fontSize: fontSizeValue,
      fontWeight: fontWeightValue,
      lineHeight: "20px",
      letterSpacing: "0em",
      textAlign: "left",
      color: "#565556",
      backgroundColor,
      // width: "75%",
      height: "auto",
      // minHeight: "38px",
      borderRadius: "8px",
      padding: "10px 15px",
    },
  })
);
